import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-rating', 'rating-singular', 'star');
Labels.set('ui-rating', 'rating-plural', 'stars');
